module.exports = __webpack_public_path__ + "img/02.857aad20.svg";